export function formatHours(value: number): string {
  return `${value.toFixed(2)}h`;
}
